import store from '@/store'
import '@/plugins/jquery'
import '@/plugins/sentry'
import 'bootstrap'
import '@/plugins/lang'
import '@/plugins/fortawesome'
import { init as notificationInit } from '@/plugins/push-notification'
import * as notificationListener from '@/components/user-notification/listeners'
import { alertIfTimezoneDiff } from '@/components/alert-timezone'
import * as pageLoading from '@/components/page-loading'
import { waitDOMContentLoaded } from '@/helpers/DOM'
import { setMomentLocale } from '@/helpers/dateHelper'

setMomentLocale()

if (store().isAuthenticate) {
    notificationListener.register()
    notificationInit()
}

// ----------------- Execute only after DOM Content is loaded ----------------------
waitDOMContentLoaded().then(() => {
    alertIfTimezoneDiff()

    // After everything is executed, we can remove the loading and show the page
    pageLoading.doneLoading()
})
